String.prototype.toUnicode = function() {
  var i;
  var result = '';
  for (i = 0; i < this.length; i++) {
    if ('ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç'.includes(this.charAt(i))) {
      result += this.charAt(i)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    } else {
      result += this.charAt(i);
    }
  }

  return result;
};
